/* eslint-disable */
import { fetch } from '@/libs/http/baseService';

// 登录
export const standardLogin = (data) => fetch.post(`/api/login/standardLogin`, data);

// 退出登录
export const logoutApi = () => fetch.get(`/api/login/logout`);

// 获取当前用户信息
export const getCurrentUser = () => fetch.get(`/api/user/getMe`);
